import React, { useEffect } from "react";
import moment from "moment";
import { Row } from "antd";
import { CustomLabel } from "../../../../Common/style";
import { scrollToTop } from "../../../../Utils";
import TeleBookingCard from "../../../../Components/TeleBookingCard";
import PAGE_CONSTANTS from "../constant";
import CONSTANTS from "../../../../Utils/constant";
import { TeleAppointmentDetails } from "../../CommonData";
import "./bookedVisits.css";

const BookedVisitsTemplate = ({bookedAppointment}) => {
  const {
    Application_Number
  } = TeleAppointmentDetails()

  const formattedAppointmentData = (appointment) => {
   return {
    appNo: Application_Number,
    date: moment(moment(appointment?.Appointment_Preferred_Date1)).format(CONSTANTS?.FORMAT_DOB),
    time: appointment?.Appointment_Preferred_Time1,
    mobile: appointment?.Insured_Mobile_Number,
    email: appointment?.Insured_Email_id
  }
  }

  useEffect(() => {
    scrollToTop();
  },[])
  return (
    <>
      <Row className="booked-appointment-heading">
        <CustomLabel font_size="24" font_weight="bold">
          {PAGE_CONSTANTS?.YOUR_TELE_MER_CONFIRMED_TITLE}
        </CustomLabel>
      </Row>
      <Row gutter={[0, 20]}>
        {bookedAppointment ?
          <TeleBookingCard {...formattedAppointmentData(bookedAppointment[0])} />
         : null}
      </Row>
    </>
  );
};

export default BookedVisitsTemplate;
